<template>
  <mobile-modal
    v-if="isMobileViewport"
    :allow-overflow="allowOverflow"
    @close="$emit('close:modal', $event)"
  >
    <template v-slot:title>
      <slot name="title"></slot>
    </template>

    <slot></slot>
  </mobile-modal>

  <modal
    v-else
    @close:modal="$emit('close:modal', $event)"
  >
    <h2 class="text-2xl font-bold text-dark-blue tracking-1 mb-6">
      <slot name="title"></slot>
    </h2>

    <slot></slot>
  </modal>
</template>

<script>
  import Modal from 'sb/elements/Modals/Modal'
  import MobileModal from './MobileModal'

  export default {

    props: {
      allowOverflow: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      /**
       * Depending on the viewport, either the normal modal will be used, or the mobile modal
       */
      isMobileViewport() {
        return screen.width < 1024
      }
    },

    components: { Modal, MobileModal }

  }
</script>
